(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-features"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const imageContainers = document.querySelectorAll('.section-did-you-know [data-parallax-image]');

    function applyParallaxEffect() {
      imageContainers.forEach((container) => {
        const min = container.offsetTop - window.innerHeight / -6;
        const max = container.offsetTop + container.offsetHeight * 2.5;
        const percentage = Math.min((window.scrollY - min) / (max - min), 1);

        const innerImage = container.querySelector('img');
        innerImage.style.transform = `translateY(${percentage * 8}%)`; //factor 8 is the speed of the parallax effect
      });
    }

    document.addEventListener('scroll', applyParallaxEffect);
    applyParallaxEffect(); // Initially apply the effect when the section is visible.
  });

  } catch(e) { console.error(e); }
})();
})();
